import { EditIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import React, { useState } from "react";
import { Media, MerchandiseCatalogItem, Product } from "types";
import { CatalogItemMediaImage } from "../Common/CatalogItemMediaImage";
import { ProductImage } from "../Common/ProductImage";
import { SecondaryButton } from "../Common/SecondaryButton";
import { UploadProductImageModal } from "./UploadProductImageModal";

export const ProductPhotoList = ({
    product,
    catalogItem,
}: {
    product?: Product;
    catalogItem?: MerchandiseCatalogItem;
}) => {
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setActiveMedia(undefined);
    };

    const handleEdit = (media?: Media) => {
        setActiveMedia(media ? media : undefined);
        setIsModalOpen(true);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeMedia, setActiveMedia] = useState<Media | undefined>(undefined);

    const productOrCatalogItem = product ?? catalogItem;
    const isPrimaryPhoto = (id: ID) => {
        return productOrCatalogItem?.photo?.id === id;
    };

    return (
        <div className="grid max-w-fit grid-cols-4 gap-y-3 gap-x-0">
            {productOrCatalogItem?.medias?.map((media) => {
                return (
                    <div key={media.id} className="group relative">
                        {isPrimaryPhoto(media.id) ? (
                            <Badge size="medium" className="absolute -top-2 left-6">
                                Primary
                            </Badge>
                        ) : null}
                        {product ? (
                            <ProductImage product={product} media={media} size="huge" />
                        ) : catalogItem ? (
                            <CatalogItemMediaImage catalogItem={catalogItem} media={media} size="huge" />
                        ) : null}
                        <SecondaryButton
                            size="small"
                            icon={<EditIcon />}
                            className="invisible absolute top-11 left-6 group-hover:visible"
                            onClick={() => handleEdit(media)}
                        >
                            Edit
                        </SecondaryButton>
                    </div>
                );
            })}

            <div
                className="m-1 flex h-28 w-28 flex-shrink-0 cursor-pointer flex-col items-center justify-center rounded-lg border-[3px] border-dashed border-gray-light"
                onClick={() => handleEdit()}
            >
                <div className="text-2xl">+</div>
                <div className="font-bold">Upload Image</div>
            </div>

            <UploadProductImageModal
                isOpen={isModalOpen}
                product={product}
                catalogItem={catalogItem}
                media={activeMedia}
                onClose={handleCloseModal}
            />
        </div>
    );
};
